module.exports = __webpack_public_path__ + "static/img/Alwyn.Davey.f9eb13d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alwyn.Davey.jpg
// module id = 3QZ2
// module chunks = 0